import { useState } from 'react';
import { usePartnerBalance } from '../../lib/partnerAuth';
import { getRemainingToMinimum, MIN_PAYOUT_USD } from '../../lib/partnerStatsFilters';
import styles from './PayoutMinimumBanner.module.css';

const DISMISS_KEY = 'payout-min-banner-dismissed';

export function PayoutMinimumBanner() {
  const { balance } = usePartnerBalance();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === '1',
  );

  if (!balance || balance.eligibility !== 'accumulating' || dismissed) {
    return null;
  }

  const remaining = getRemainingToMinimum(balance.unpaid);

  function dismiss() {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  }

  return (
    <div className={styles.banner} role="status">
      <div className={styles.content}>
        <strong className={styles.headline}>
          ${balance.unpaid.toFixed(2)} earned — ${remaining.toFixed(2)} to minimum payout
        </strong>
        <p className={styles.text}>
          Payouts are sent once your balance reaches ${MIN_PAYOUT_USD}. Keep sharing your link!
        </p>
      </div>
      <button type="button" className={styles.dismiss} onClick={dismiss} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
}
